var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8514 20.1723C24.8514 19.2011 24.064 18.4129 23.092 18.4129H12.5364L11.293 17.1688C10.9632 16.839 10.5155 16.6535 10.0489 16.6543H7.25891C6.28763 16.6543 5.49951 17.4417 5.49951 18.4137V30.7287C5.49951 31.7 6.28687 32.4881 7.25891 32.4881H23.092C24.0633 32.4881 24.8514 31.7008 24.8514 30.7287V20.1731V20.1723Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.904 26.9171C27.8753 26.9171 28.6634 26.1297 28.6634 25.1577V14.602C28.6634 13.6307 27.876 12.8426 26.904 12.8426H16.3484L15.105 11.5985C14.7752 11.2687 14.3275 11.0832 13.8609 11.084H11.0709C10.0996 11.084 9.31152 11.8713 9.31152 12.8434V14.0024",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7414 21.345C31.7127 21.345 32.5008 20.5577 32.5008 19.5856V9.03074C32.5008 8.05946 31.7134 7.27134 30.7414 7.27134H20.1858L18.9424 6.02722C18.6126 5.69738 18.1649 5.51194 17.6983 5.5127H14.9083C13.937 5.5127 13.1489 6.30006 13.1489 7.2721V8.4311",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdocs);
export default __webpack_public_path__ + "static/media/edocs.eca3f36b95b71abe94557f38df97b1ac.svg";
export { ForwardRef as ReactComponent };